import React from "react";
import CommonModal from "../../../components/Common/CommonModal";
import CommonRadioOpcoes from "../../../components/forms/CommonRadioOpcoes";
import { handleChangeNameValue } from "../../../helpers/handleFormChanges";
import PropTypes from "prop-types";

function DownloadMassaModal({ DownloadModalHook, valuesHook, downloadMassa }) {
  const { downloadMassaModal, setDownloadMassaModal } = DownloadModalHook;
  const { values, setValues } = valuesHook;

  return (
    <CommonModal
      title="Download em massa"
      is_open_modal={downloadMassaModal}
      set_is_open_modal={setDownloadMassaModal}
      size="md"
      buttons={[
        <button
          key={`download-massa`}
          type="button"
          onClick={() => {
            downloadMassa();
          }}
          className="btn btn-success"
        >
          Download
        </button>,
      ]}
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          downloadMassa();
        }}
      >
        <div className="row">
          <div className="col">
            <CommonRadioOpcoes
              label="Opção de download:"
              id="opcao_download"
              upValue={values.opcao_download}
              lowValue={!values.opcao_download}
              upOnChange={(e) =>
                handleChangeNameValue(
                  "opcao_download",
                  e.target.checked,
                  values,
                  setValues
                )
              }
              lowOnChange={(e) =>
                handleChangeNameValue(
                  "opcao_download",
                  !e.target.checked,
                  values,
                  setValues
                )
              }
              upText={`Somente ${values?.tipo === "FolhaPagamento" ? "folhas de pagamento" : "pró-labores"} ${values?.tipo === "FolhaPagamento" ? "selecionadas" : "selecionados"}`}
              lowText={`Todas ${values?.tipo === "FolhaPagamento" ? "folhas de pagamento" : "pró-labores"} do período selecionado`}
            />
          </div>
        </div>
      </form>
    </CommonModal>
  );
}

DownloadMassaModal.propTypes = {
  DownloadModalHook: PropTypes.shape({
    downloadMassaModal: PropTypes.bool.isRequired,
    setDownloadMassaModal: PropTypes.func.isRequired,
  }).isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  downloadMassa: PropTypes.func.isRequired,
};

export default DownloadMassaModal;
